import { slicedToArray as _slicedToArray, defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useEffect } from 'react';
import { i18n } from '../../i18n/translate.js';
import { FAIcon } from '../fa-icon/component.js';
var NOTIFICATION_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  INFO: 'info',
  WARNING: 'warning'
};

var InlineNotification = function InlineNotification(props) {
  var _props$type = props.type,
      type = _props$type === void 0 ? NOTIFICATION_TYPES.SUCCESS : _props$type,
      _props$show = props.show,
      show = _props$show === void 0 ? true : _props$show,
      children = props.children,
      closeAction = props.closeAction,
      dataAttribute = props.dataAttribute;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = useState('circle-check'),
      _useState4 = _slicedToArray(_useState3, 2),
      iconType = _useState4[0],
      setIconType = _useState4[1];

  useEffect(function () {
    setVisible(show);
  }, [show]);
  useEffect(function () {
    var iconsMap = _defineProperty(_defineProperty(_defineProperty({}, NOTIFICATION_TYPES.ERROR, 'circle-minus'), NOTIFICATION_TYPES.INFO, 'circle-info'), NOTIFICATION_TYPES.WARNING, 'triangle-exclamation');

    if (iconsMap[type]) {
      setIconType(iconsMap[type]);
    }
  }, [type]);

  var onClose = function onClose() {
    setVisible(false);
  };

  var close = closeAction || onClose;

  if (!visible) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "inline-notification-banner ".concat(type),
    "data-attribute": dataAttribute
  }, /*#__PURE__*/React.createElement("div", {
    className: "banner-icon"
  }, /*#__PURE__*/React.createElement(FAIcon, {
    icon: iconType
  })), /*#__PURE__*/React.createElement("div", {
    className: "banner-text"
  }, children), /*#__PURE__*/React.createElement("button", {
    className: "banner-close-button",
    "aria-label": i18n.t('Dismiss Notification'),
    onClick: close
  }, /*#__PURE__*/React.createElement(FAIcon, {
    icon: "xmark",
    additionalClasses: "banner-close"
  })));
};

InlineNotification.displayName = "InlineNotification";
export { InlineNotification };